export const ACTION_TYPES = {
  MAP_STATE_CLEARED: 'MAP_STATE_CLEARED',
  SET_COMMUTE_DESTINATION: 'SET_COMMUTE_DESTINATION',
  SET_FILTERED_AREAS: 'SET_FILTERED_AREAS',
  SET_POI_MARKERS: 'SET_POI_MARKERS',
  RECEIVE_AREAS_IN_MUNICIPALITY: 'RECEIVE_AREAS_IN_MUNICIPALITY',
  RECEIVE_ALL_AREAS_EXCLUDE_BY_MUNICIPALITY: 'RECEIVE_ALL_AREAS_EXCLUDE_BY_MUNICIPALITY',

  FETCH_MUNICIPALITY_STARTED: 'FETCH_MUNICIPALITY_STARTED',
  FETCH_MUNICIPALITY_SUCCEEDED: 'FETCH_MUNICIPALITY_SUCCEEDED',
  FETCH_MUNICIPALITY_FAILED: 'FETCH_MUNICIPALITY_FAILED',
  MUNICIPALITY_DATA_CLEARED: 'MUNICIPALITY_DATA_CLEARED',
  FETCH_CAREERS_FOR_MUNICIPALITY_STARTED: 'FETCH_CAREERS_FOR_MUNICIPALITY_STARTED',
  FETCH_CAREERS_FOR_MUNICIPALITY_SUCCEEDED: 'FETCH_CAREERS_FOR_MUNICIPALITY_SUCCEEDED',
  FETCH_CAREERS_FOR_MUNICIPALITY_FAILED: 'FETCH_CAREERS_FOR_MUNICIPALITY_FAILED',

  FETCH_ABOUT_MUNICIPALITY_STARTED: 'FETCH_ABOUT_MUNICIPALITY_STARTED',
  FETCH_ABOUT_MUNICIPALITY_SUCCEEDED: 'FETCH_ABOUT_MUNICIPALITY_SUCCEEDED',
  FETCH_ABOUT_MUNICIPALITY_FAILED: 'FETCH_ABOUT_MUNICIPALITY_FAILED',

  // Toggle
  START_DROPDOWN_OPENED: 'START_DROPDOWN_OPENED',
  START_DROPDOWN_CLOSED: 'START_DROPDOWN_CLOSED',
  NAVBAR_OPENED: 'NAVBAR_OPENED',
  NAVBAR_CLOSED: 'NAVBAR_CLOSED',
  NAVBAR_TAB_CHANGED: 'NAVBAR_TAB_CHANGED',
  NAVBAR_SPINNER_TOGGLED: 'NAVBAR_SPINNER_TOGGLED',
  COMMUTE_MODAL_OPENED: 'COMMUTE_MODAL_OPENED',
  COMMUTE_MODAL_CLOSED: 'COMMUTE_MODAL_CLOSED',
  FEEDBACK_MODAL_OPENED: 'FEEDBACK_MODAL_OPENED',
  FEEDBACK_MODAL_CLOSED: 'FEEDBACK_MODAL_CLOSED',

  // Language
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',

  // Career
  FETCH_CAREERS_STARTED: 'FETCH_CAREERS_STARTED',
  FETCH_CAREERS_SUCCEEDED: 'FETCH_CAREERS_SUCCEEDED',
  FETCH_CAREERS_FAILED: 'FETCH_CAREERS_FAILED',


  QUESTION_MODAL_OPENED: 'QUESTION_MODAL_OPENED',
  QUESTION_MODAL_CLOSED: 'QUESTION_MODAL_CLOSED',
  SUBSCRIPTION_MODAL_OPENED: 'SUBSCRIPTION_MODAL_OPENED',
  SUBSCRIPTION_MODAL_CLOSED: 'SUBSCRIPTION_MODAL_CLOSED',
  GDPR_MODAL_OPENED: 'GDPR_MODAL_OPENED',
  GDPR_MODAL_CLOSED: 'GDPR_MODAL_CLOSED',

  RECEIVE_AREA_OVERVIEW_DATA: 'RECEIVE_AREA_OVERVIEW_DATA',
  RECEIVE_AREA_AVERAGE_PRICE: 'RECEIVE_AREA_AVERAGE_PRICE',
  SET_MAP_VALUES: 'SET_MAP_VALUES',
  CHANGE_FAV_SORT_OPTION: 'CHANGE_FAV_SORT_OPTION',
  TOGGLE_MAP_LAYER: 'TOGGLE_MAP_LAYER',
  TOGGLE_HAMBURGER_MENU: 'TOGGLE_HAMBURGER_MENU',
  TOGGLE_CONTACT_NOTIFICATION: 'TOGGLE_CONTACT_NOTIFICATION',
  TOGGLE_FILTER_STATE: 'TOGGLE_FILTER_STATE',
  TOGGLE_FILTER_EXPANDED: 'TOGGLE_FILTER_EXPANDED',
  TOGGLE_GOT_COMMUTE_FOR_AREAS: 'TOGGLE_GOT_COMMUTE_FOR_AREAS',
  UPDATE_AREA_FAVOURITE: 'UPDATE_AREA_FAVOURITE',
  UPDATE_AREA_FAVOURITES: 'UPDATE_AREA_FAVOURITES',
  UPDATE_SELECT_FAVOURITE: 'UPDATE_SELECT_FAVOURITE',
  DELETE_SELECTED_FAVOURITES: 'DELETE_SELECTED_FAVOURITES',
};

export const FETCH_STATUS = {
  IDLE: 'IDLE',
  FETCHING: 'FETCHING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export const NOTIFICATION_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
};

export const SUBSCRIBE_ROLE = {
  STUDENT: 'STUDENT',
  WORKING: 'WORKING',
  LOOKING_FOR_WORK: 'LOOKING_FOR_WORK',
};

export const SUBMIT_QUESTION_ROLES = {
  FORSKOLAN: 'FORSKOLAN',
  GYMNASIET: 'GYMNASIET',
  GRUNDSKOLAN: 'GRUNDSKOLAN',
  UNIVERSITET: 'UNIVERSITET',
  ANNAN: 'ANNAN',
};

export const TAB_TYPES = {
  FILTER: 'FILTER',
  FAVORITES: 'FAVORITES',
  SEARCH: 'SEARCH',
  CONTACT: 'CONTACT',
  TEACHER: 'TEACHER',
};

export const LINKS = {
  DATA_INSPEKTIONEN: 'https://www.datainspektionen.se/vagledningar/for-dig-som-privatperson/klagomal-och-tips',
  STREET_VIEW: 'https://www.google.com/maps/embed/v1/streetview?key=AIzaSyD9mys_yjq-VFWtgBYErp7yg82Pa9IViUc&location=',
};

export const SECTION_TYPE = {
  TEXT: 'TEXT',
  IMAGES: 'IMAGES',
  VIDEO: 'VIDEO',
  FAQ: 'FAQ',
  STREET_VIEW: 'STREET_VIEW',
  COMMUTE_TIME: 'COMMUTE_TIME',
  HOUSE_LISTINGS: 'HOUSE_LISTINGS',
};

export const URL_TYPES = {
  ABOUT_MUNICIPALITY: 'about-municipality',
  ABOUT_SERVICE: 'about-service',
  CAREER: 'career',
  START: 'start',
  MAP: 'map',
  AREA: 'area',
  COMPARE: 'compare',
  LICENSES: 'licenses',
};

export const CAREER_STATUS = {
  LIVE: 'LIVE',
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
};

export const HOUSING_TYPES = {
  HOUSE: 2,
  APARTMENT: 1,
};

export const FAV_SORT_OPTIONS = {
  VICINITY: '1',
  ASC: '2',
};

export const FACT_TYPES = {
  COMMUTE_DESTINATION: 'commuteDestination',
  AVERAGE_HOUSE_COST: 'averageHouseCost',
  AVERAGE_FLAT_COST: 'averageFlatCost',
  MEDICAL_CENTER: 'medicalCenter',
  GROCERY_STRORE: 'groceryStore',
  PHARMACY: 'pharmacy',
  HOSPITAL: 'hospital',
};

export const FACT_DISTANCE_QUERIES = [
  { query: '', googleType: 'pharmacy', type: FACT_TYPES.PHARMACY },
  { query: 'Livsmedelsbutik', googleType: '', type: FACT_TYPES.GROCERY_STRORE },
  { query: 'Sjukhus', googleType: '', type: FACT_TYPES.HOSPITAL },
  { query: 'Vårdcentral', googleType: '', type: FACT_TYPES.MEDICAL_CENTER },
];

export const QUERY_PARAMS = {
  AREAS: 'areas',
  SORT: 'sort',
  MUNICIPALITIES: 'municipalities',
};

export const MAP_PARAMS = {
  MIN_ZOOM: 6,
  SWE_BOUNDS: [
    [69.724907, 27.145762],
    [54.587985, 10.002162],
  ],
};

export const DISTANCE_API_CALL_TYPES = { AREA_CARD: 1, FILTER: 2 };

export const CONF_NAME = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : 'dev';

export const THEMES = new Map([
  ['green', { classes: ['theme-green-primary', 'theme-green-secondary'], primaryColor: '#2ba777' }],
  ['orange', { classes: ['theme-orange-primary', 'theme-orange-secondary'], primaryColor: '#de5f3b' }],
  ['blue', { classes: ['theme-blue-primary', 'theme-blue-secondary'], primaryColor: '#4a90a6' }],
]);

export const MAX_COMPARE_VALUE = 10;

export const IMAGE_BUCKET_URL = process.env.REACT_APP_IMAGE_BUCKET_URL;

export const MATOMO_BASE_URL = process.env.REACT_APP_MATOMO_BASE_URL;

export const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID;

export const MATOMO_ENABLED = !!(MATOMO_BASE_URL && MATOMO_SITE_ID);



// WEBPACK FOOTER //
// ./src/Constants.js